import React from 'react';

/**
 * DescriptionList — key/value pairs for detail panels (folios, guest info).
 *
 * Props:
 *   items: Array<{ term, description }>
 *   layout: 'horizontal' | 'stacked'   — default 'horizontal'
 *   columns: number                    — grid columns (default 1)
 */
const DescriptionList = ({ items = [], layout = 'horizontal', columns = 1, className = '', children }) => (
  <dl
    className={`ps-dl ps-dl--${layout} ${className}`.trim()}
    style={columns > 1 ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` } : undefined}
  >
    {children || items.map((it, i) => (
      <div className="ps-dl__row" key={i}>
        <dt className="ps-dl__term">{it.term}</dt>
        <dd className="ps-dl__desc">{it.description}</dd>
      </div>
    ))}
  </dl>
);

export default DescriptionList;
